import React, { useState } from 'react';
import { NavLink } from "react-router-dom";
import { Row, Col, Button, notification, Upload } from 'antd';
import { ArrowLeftOutlined, DownloadOutlined, UploadOutlined, CloseCircleOutlined } from "@ant-design/icons";

import { PrintDialog } from "../../../common/dialog/PrintDialog";
import { Dialog } from "../../../common/dialog/Dialog";

import ApplicationService from "../../../services/ApplicationService";
import StorageService from '../../../services/StorageService';

import { STATES, DOCUMENT_TYPES } from "../../../helpers/constants";
import { getCurrentBranchUuId, getToken } from "../../../helpers/token";
import { getUrlPath, getDayDiff } from "../../../helpers/parsers";

const ActionsBar = ({ application, appStateChange, state, setPrintedDocuments, setAttachments }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [viewCode, setViewCode] = useState(false);
    const [printDialog, setPrintDialog] = useState(false);
    const { completeSheet } = application;

    const disabled = !application?.customer?.emailVerified;

    const printDocuments = () => {
        ApplicationService.printPdf(application.uuId).then(({ documentsPrinted }) => {
            setPrintedDocuments(documentsPrinted);

            if (completeSheet) {
                ApplicationService.getPdf(getUrlPath(completeSheet))
                    .then(response => response.blob())
                    .then(data => {
                        let newWindow = window.open('');
                        newWindow.location.href = URL.createObjectURL(data);
                        newWindow.focus();

                        ApplicationService.generateCode(application.uuId, 'SMS')
                            .catch(e => {
                                notification.error({
                                    message: e,
                                    className: 'ant-notification',
                                })
                            })
                            .finally(() => {
                                setViewCode(true)
                                setPrintDialog(false)
                            })
                    })
            }
        })


    };

    const printReceipt = () => {
        StorageService.getReceipt(application.uuId).then(response => response.blob())
            .then(data => {
                setPrintedDocuments(application.documentsPrinted.concat(DOCUMENT_TYPES.RECEIPT_SHEET));

                let newWindow = window.open('');
                newWindow.location.href = URL.createObjectURL(data);
                newWindow.focus();
            })
    }

    const handleVisible = (visible) => {
        ApplicationService.getApplication(application.uuId).then(({ state }) => {
            if (state !== STATES.agreed) {
                notification.info({
                    message: 'Վարկային փաթեթեը հաջողությամբ հատատված է։ Խնդրում ենք թարմացնել էջը՝ ապրանքը բաց թողնելու համար։',
                    className: 'ant-notification',
                });
            } else {
                setModalVisible(visible);

                if (!visible) {
                    setViewCode(false);
                    setPrintDialog(false);
                }
            }
        })
    }

    const generateCode = (type) => {
        const documentsPrinted = application.documentsPrinted || []
        if (type === 'SMS' && documentsPrinted.indexOf(DOCUMENT_TYPES.COMPLETE_SHEET) === -1) {
            setPrintDialog(true);
        } else {
            ApplicationService.generateCode(application.uuId, type).then(() => {
                if (type === 'EMAIL') {
                    setModalVisible(false);
                    notification.success({
                        message: 'Հաճախորդի էլ. հասցեին ուղարկվել է նամակ հողումով։',
                        className: 'ant-notification',
                    });
                } else {
                    setViewCode(true);
                }
            }).catch(e => {
                notification.error({
                    message: e,
                    className: 'ant-notification',
                });
            })
        }
    }

    const resendCode = () => {
        ApplicationService.generateCode(application.uuId, 'SMS').then(() => {
            notification.success({
                message: 'Sms կոդը կրկին ուղղարկվել է',
                className: 'ant-notification',
            });
        }).catch(e => {
            notification.error({
                message: e,
                className: 'ant-notification',
            });
        })
    }

    const identifyCode = (code) => {
        ApplicationService.identifyCode(application.uuId, code).then((res) => {
            if (res === 'APPLICATION_IDENTIFICATION_FAILURE') {
                notification.error({
                    message: 'Սխալ մուտքային կոդ',
                    className: 'ant-notification',
                });
            } else if (res === 'APPLICATION_IDENTIFICATION_BLOCKED') {
                appStateChange(STATES.finalizationBlocked);
                notification.error({
                    message: 'Սխալ մուտքագրումների քանակը գերազանցել է թույլատրելի 5-ը։ Հայտը արգելափակվել է։',
                    className: 'ant-notification',
                });
            }else if (res.code === 'incorrect.verification.code'){
                notification.error({
                    message:  'Սխալ վավերականացման կոդ',
                    className: 'ant-notification',
                });
            } else {
                setModalVisible(false);
                setViewCode(false);
                appStateChange(res.state);
                notification.success({
                    message: 'Վարկային փաթեթը հաջողությամբ Հաստատված է:',
                    className: 'ant-notification',
                });
            }
        }).catch(e => {
            notification.error({
                message: e,
                className: 'ant-notification',
            });
        })
    }

    const uploadStateChange = ({ file }) => {
        if (file && file.status === 'done') {
            const attachments = application.attachments || [];
            setAttachments(attachments.concat(file.response))
        }
    }

    const deleteAttachment = (attachment) => {
        StorageService.deleteAttachment(application.uuId, attachment.split('/')[2])
            .then(setAttachments(application.attachments.filter(file => file !== attachment)))
    }

    const downloadAttachment = (attachment) => {
        StorageService.getAttachment(attachment).then(res => res.blob())
            .then(data => {
                let newWindow = window.open('');
                newWindow.location.href = URL.createObjectURL(data);
                newWindow.focus();
            })
    }

    if (application.merchantBranchUuId !== getCurrentBranchUuId()) {
        return (
            <div>
                <Row justify={'space-between'} className='actions-bar'>
                    <Col className='my-auto' style={{ fontSize: 18 }}>
                        <NavLink to={'/applications'}>
                            <ArrowLeftOutlined className='mr-1' />
                        </NavLink>
                        Դիմումի մանրամասներ
                    </Col>
                </Row>
            </div>
        )
    }

    return <div>
        <Row justify={'space-between'} className='actions-bar'>
            <Col className='my-auto' style={{ fontSize: 18 }}>
                <NavLink to={'/applications'}>
                    <ArrowLeftOutlined className='mr-1' />
                </NavLink>
                Դիմումի մանրամասներ
            </Col>
            <Col className='my-auto'>

                {state === STATES.signed ? (
                    <Button
                        onClick={printReceipt}
                        className='btn-yellow'
                        size={"large"}
                        style={{ marginRight: 16 }}
                    >
                        <DownloadOutlined />
                        Տպել ստացականը
                    </Button>
                ) : (
                    <>
                        {state === STATES.agreed && (
                            <>
                                <Button
                                  size='large'
                                  disabled={disabled}
                                  onClick={() => handleVisible(true)}
                                  className={disabled ? '' : 'btn-yellow'}
                                >
                                    Ավարտել գործարքը
                                </Button>
                                {!printDialog ? (
                                    <Dialog
                                        handleCancel={handleVisible}
                                        generateCode={generateCode}
                                        identifyCode={identifyCode}
                                        resendCode={resendCode}
                                        visible={modalVisible}
                                        viewCode={viewCode}
                                    />
                                ) : (
                                    <PrintDialog
                                        handleCancel={handleVisible}
                                        visible={modalVisible}
                                        handleAction={printDocuments}
                                    />
                                )}

                            </>
                        )}
                    </>
                )}

                {(application.state !== STATES.finished || getDayDiff(application.updated) < 2) && application.documentsPrinted.indexOf(DOCUMENT_TYPES.RECEIPT_SHEET) !== -1 && (
                    <React.Fragment>
                        {(!application.attachments || application.attachments.length < 3) && (
                            <Upload
                                name="attachment"
                                accept=".pdf,.jpg,.png,.gif,.bmp,.webp"
                                action={`/api/storage/upload`}
                                data={{ applicationUuid: application.uuId }}
                                headers={{ 'Authorization': `Bearer ${getToken()}` }}
                                showUploadList={false}
                                onChange={uploadStateChange}
                            >
                                <Button
                                    className='btn-yellow'
                                    size={"large"}
                                    style={{ marginRight: 16 }}
                                >
                                    <UploadOutlined />
                                    {(!application.attachments || application.attachments.length === 0) && 'Ներբեռնել ստորագրված փաստաթուղթը'}
                                </Button>
                            </Upload>
                        )}
                        {application.attachments && application.attachments.map(attachment => (
                            <span className='mr-1' size='large' style={{ background: '#f0f2f3', padding: '12px 16px' }}>
                                <a onClick={() => downloadAttachment(attachment)}>{attachment.split('/')[2]}</a>
                                {!(state === STATES.finished && application.attachments.length === 1) && (
                                    <CloseCircleOutlined style={{ marginLeft: 12 }} onClick={() => deleteAttachment(attachment)} />
                                )}
                            </span>
                        ))}
                    </React.Fragment>
                )}

            </Col>
        </Row>
    </div>
};


export default ActionsBar;